import type { LideNaStavbeFirma } from '../../api/types.js';

/**
 * Normalizace pole „lidé na stavbě" (editSchema deníku je pole firem s počty);
 * starší data mohou nést objekt { firma: počet } — UI kvůli tomu nikdy nespadne.
 * Vyčleněno z DenikPage, ať ho může sdílet i kontrolní souhrn podpisu.
 */
export function normalizujLidi(v: unknown): LideNaStavbeFirma[] {
  if (Array.isArray(v)) {
    return v.filter(
      (l): l is LideNaStavbeFirma =>
        !!l && typeof l === 'object' && typeof (l as LideNaStavbeFirma).nazev === 'string',
    );
  }
  if (v && typeof v === 'object') {
    return Object.entries(v as Record<string, unknown>).map(([nazev, pocet]) => ({
      nazev,
      pocet: typeof pocet === 'number' ? pocet : 0,
    }));
  }
  return [];
}
